export default __webpack_public_path__ + "static/media/Iconly-Bold-Graph.68be543d.svg";